import {
  IAuditorModel
} from "./../../../../models/alocar-equipe-component";
import { IAlocarEquipeModel } from "./../../../../../app/models/alocar-equipe-component";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseFormComponent } from "./../../../../../app/shared/components/base-form/base-form.component";
import { Subscription } from "rxjs";
import { IAuditorCoordenacaoModel } from "./../../../../../app/models/auditor-coordenacao.model";
import { ISubtipoAuditoriaModel } from "./../../../../../app/models/subtipo-auditoria.model";
import { IPaaCoordenacaoAuditorModel } from "./../../../../../app/models/paa-coordenacao-auditor.model";
import { IUnidadeGestoraModel } from "../../../../models/unidade-gestora.model";
import { IOsaExecucaoModel, IOsaExecucaoUgSubTipoModel } from "../../../../models/osa-execucao-model";
import { OsaExecucaoService } from "../../../../services/osa-execucao.service";
import { OsaService } from "../../../../services/osa.service";
import { FormControl, FormGroup } from "@angular/forms";
import { ModalIncluirUgSubTipoComponent } from "./unidade-gestora-sub-tipo/modal-incluir-ug-sub-tipo/modal-incluir-ug-sub-tipo.component";
import Swal from 'sweetalert2';
import { SharedService } from "../../../../services/shared.service";

export interface PlanejamentoUgSubtipo {
  planejamentoId: number;
  unidadeGestora: IUnidadeGestoraModel;
  subtipoAuditoria: ISubtipoAuditoriaModel;
}

@Component({
  selector: 'app-osa-execucao-aba-informacoes-basicas',
  templateUrl: './osa-execucao-aba-informacoes-basicas.component.html',
  styleUrls: ['./osa-execucao-aba-informacoes-basicas.component.scss']
})

export class OsaExecucaoAbaInformacoesBasicasComponent
  extends BaseFormComponent
  implements OnInit, AfterViewInit, OnDestroy {
  // @Output() modelChange = new EventEmitter<IOsaExecucaoModel>();
  @Input() model: IOsaExecucaoModel;
  clickEventSubscription: Subscription
  public subTipoModel: ISubtipoAuditoriaModel[] = [] as ISubtipoAuditoriaModel[];
  public paaEquipeModel: IPaaCoordenacaoAuditorModel[] = [] as IPaaCoordenacaoAuditorModel[];
  public displayedColumns: string[] = ["auditor"];
  public displayedColumnsSubtipo: string[] = ["nome"];
  public equipeDataSource = new MatTableDataSource<IAuditorModel>([]);
  // public model: IOsaExecucaoModel = {} as IOsaExecucaoModel;
  public coordenadoresAuditoria = [] as IAuditorCoordenacaoModel[];
  public semDados = true;
  public id: number;
  public subtipoNoData = true;
  public semDadosSubTipo = true;
  public subTipoSelecionado: number;
  public submitted: boolean = false;
  public dataSourceUgSubTipos = new MatTableDataSource<IOsaExecucaoUgSubTipoModel>([]);
  public displayedColumnsUg: string[] = ["ug", "subtipo", "statusUg", "numeroOsa", "actions"];
  public alocarEquipeModel: IAlocarEquipeModel = {} as IAlocarEquipeModel;

  @Input() public visualizar;

  @ViewChild("TableTwoPaginator", { static: true })
  tableTwoPaginator: MatPaginator;
  @ViewChild("tabela2", { static: true }) tabela2: MatSort;

  @ViewChild("TableTreePaginator", { static: true })
  tableTreePaginator: MatPaginator;
  @ViewChild("tabela3", { static: true }) tabela3: MatSort;

  public form = new FormGroup({
  });

  private validacaoRequestSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    private osaService: OsaService,
    private osaExecucaoService: OsaExecucaoService,
    private sharedService: SharedService
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model']?.currentValue) {
      if (this.model?.osa) {
        this.buscar();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.validacaoRequestSubscription) {
      this.validacaoRequestSubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {

    this.equipeDataSource.paginator = this.tableTwoPaginator;
    this.equipeDataSource.sort = this.tabela2;
    this.equipeDataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public buscar() {
    if (!this.model?.osa) return;

    const planejamento = this.model.osa.planejamento;
    const opa = planejamento?.opa;

    if (planejamento?.id) {
      this.sharedService.setPlanejamentoId(planejamento.id);
    }

    if (this.model.osa) {

      this.sharedService.setPlanejamentoId(this.model.osa.planejamentoId);
      this.sharedService.setNumeroOsa(this.model.osa.numero);
      this.sharedService.setDataFimRealizacao(this.model.osa.dataFimRealizacao);
      this.sharedService.setNomeUG(this.model.osa.unidadeGestora.nome + '-' + this.model.osa.unidadeGestora.sigla);
    }

    this.alocarEquipeModel.unidadeGestora = opa?.unidadeGestora || null;
    this.alocarEquipeModel.tipoAuditoria = opa?.tipoAuditoria || null;

    this.dataSourceUgSubTipos.data = this.model?.osaExecucaoUgSubTipo || [];
    this.dataSourceUgSubTipos.paginator = this.tableTreePaginator;
    this.dataSourceUgSubTipos.sort = this.tabela3;
    this.dataSourceUgSubTipos.sortingDataAccessor = this.sortingUgSubtiposDataAccessor;

    if (this.model?.osa?.id) {
      this.obterAlocarEquipe(this.model.osa.id);
    }
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

 public obterAlocarEquipe(idOsa: number) {
  const siglaUg = this.model?.osa?.unidadeGestora?.sigla;

  this.osaService.obterAlocarEquipeOsaId(idOsa, siglaUg).then((res) => {

    let auditoresSelecionados = res.dados.map((a) => {
      return {
        auditorId: a.auditorId,
        nomeAuditor: a.nomeAuditor,
        id: a.id,
      } as IAuditorModel;
    });
    const [dataInicio, dataFim] = [
      res?.dados[0]?.dataInicio,
      res?.dados[0]?.dataFim,
    ];

    auditoresSelecionados = auditoresSelecionados.filter(function (a) {
      return (
        !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
      );
    }, Object.create(null));

    this.equipeDataSource.data = auditoresSelecionados;
    this.alocarEquipeModel.auditoresSelecionados = auditoresSelecionados;
    if (dataInicio?.toString())
      this.alocarEquipeModel.dataInicio = new Date(dataInicio.toString());
    if (dataFim?.toString())
      this.alocarEquipeModel.dataFim = new Date(dataFim.toString());
  });
}
  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "auditor":
        return item?.nomeAuditor;
      case "nome":
        return item?.nome;
      default:
        return item[property];
    }
  };

  public sortingUgSubtiposDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item?.subTipoAuditoria?.nome;
      default:
        return item[property];
    }
  };

  public modalIncluirUg() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";
    dialogConfig.width = "800px";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      osaExecucaoId: this.model.id
    };
    const modal = this.matDialog.open(
      ModalIncluirUgSubTipoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((sucesso) => {
      if (sucesso) {
        this.buscar();
      }
    });
  }

  public excluirUg(ugId: number, subtipoId: number) {

    Swal.fire({
      title: "Excluir Registro",
      text: "Tem certeza que deseja excluir esse Registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {

        this.osaExecucaoService.excluirUgSubTipo(this.model.id, ugId, subtipoId)
          .then((res) => {
            if (res.sucesso) {
              this.exibirMensagemSucesso(res.mensagem.descricao)
              this.buscar();
            }
            else {
              this.exibirMensagemErro(res.mensagem.descricao)
            }
          })
          .catch((err) => this.exibirMensagemErro(err.mensagem.descricao))
      }
    });
  }
}
